const ErrorAlert = ({ error, errors }) => {
  let combined = errors ? errors.filter((error) => !!error) : []
  if (error) {
    combined.push(error)
  }
  if (combined.length) {
    return (
      <div className="velorbis-customizer-error-alert">
        {combined.map((error, i) => (
          <div key={i}>{error}</div>
        ))}
      </div>
    )
  } else {
    return null
  }
}
export default ErrorAlert
